export default __webpack_public_path__ + "static/media/manual2.5c400549.png";